import { Add, Category, Close, CloseFullscreen, Delete, Edit, Fullscreen } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../../ApiOld/Api/useApi';
import { ApplyCategoryTemplateRequest, BuildingVovClient, CategoryTemplateDTO, CreateCategoryTemplateRequest, DeleteCategoryTemplateRequest, ImageCategoryVovClient, UpdateCategoryTemplateRequest } from '../../../../ApiOld/Api/ApiServerVov';
import CategoryTemplateDetailDialog from './CategoryTemplateDetailDialog';
import DeleteDialog from '../../../Shared/Layouts/DeleteDialog';

interface CategoryTemplateDialogProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
    buildingId?: number;
}
export default function CategoryTemplateDialog(props: CategoryTemplateDialogProps) {
    const { open, onClose, buildingId } = props;

    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
    const [categories, setCategories] = useState<CategoryTemplateDTO[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<CategoryTemplateDTO>();
    const { authorizedApi: authorizedApiCategory } = useApi(ImageCategoryVovClient);
    const { authorizedApi: authorizedApiBuilding } = useApi(BuildingVovClient);
    const [selectionModel, setSelectionModel] = useState<CategoryTemplateDTO>();
    const [deleteCategory, setDeleteCategory] = useState<CategoryTemplateDTO>();
    const [fullScreenLocal, setFullScreenLocal] = useState(false);

    var theme = useTheme();

    useEffect(() => {
        if (open) {
            setSelectionModel(undefined);
            refreshData();
        }
    }, [open]);

    const refreshData = () => {
        authorizedApiCategory.getCategoryTemplates().then((data) => {
            setCategories(data.templates ?? []);
        });
    }

    function TransitionLeft(props: any) {
        return <Slide {...props} direction='left' />;
    }
    const handleClose = (event: any) => {
    };

    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            fullScreen={fullScreenLocal}
            onClose={() => { onClose(false) }}
            aria-labelledby="category-dialog-title"
            aria-describedby="category-dialog-description"
        >
            <DialogTitle id="category-dialog-title" >
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant='h5'>{t('templatesOfCategories')}</Typography>

                    <div style={{ float: 'right', display: 'flex', alignContent: 'flex-end' }}>
                        <div style={{ marginTop: '-14px' }}>
                            <IconButton onClick={() => { setFullScreenLocal(!fullScreenLocal) }} >
                                {fullScreenLocal ? <CloseFullscreen /> : <Fullscreen />}
                            </IconButton>
                            <IconButton onClick={() => onClose(false)}><Close /></IconButton>
                        </div>
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '10px', padding: '8px', position: 'relative', mt: 1, minWidth: '300px' }}>
                    <Button size='small' disabled={buttonDisabled} onClick={() => {
                        let novy = new CategoryTemplateDTO({
                            name: '',
                            templateItems: [],
                            id: categories.filter(p => p.id! < 0).length > 0 ? Math.min(...categories.filter(p => p.id! < 0).map(p => p.id!)) - 1 : -1
                        });
                        setSelectedCategory(novy);
                    }} sx={{ background: theme.palette.primary.main, color: 'black', margin: 1, px: 1 }} startIcon={<Add />}>
                        {t('addTemplate')}
                    </Button>
                    {categories.map((category) => {
                        return <Box key={category.id} sx={{ display: 'flex', alignItems: 'center', padding: 1, margin: 1, borderRadius: '10px', cursor: 'pointer', backgroundColor: selectionModel?.id === category.id ? '#FFC60066' : 'transparent' }} onClick={() => { setSelectionModel(category) }}>

                            <Box sx={{
                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                borderRadius: '10px',
                                padding: 1,
                                mr: 1,
                                flex: 1  // This makes the Box take all remaining space

                            }}>
                                <Typography variant='body2'>{category.name}</Typography>
                            </Box>
                            <IconButton size="small" onClick={() => { setSelectedCategory(category) }}><Edit /></IconButton>
                            <IconButton size="small" onClick={() => { setDeleteCategory(category) }}><Delete /></IconButton>
                        </Box>;

                    })}
                </Box>
                <Snackbar
                    TransitionComponent={TransitionLeft}
                    open={false}
                    autoHideDuration={5000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }} >
                    <Alert onClose={handleClose} severity="warning">
                        <AlertTitle>{t('files.categoryAlreadyExists')}</AlertTitle>
                        {t('files.unableToCreateCat')}
                    </Alert>
                </Snackbar>

                <CategoryTemplateDetailDialog open={selectedCategory !== undefined}
                    onClose={(template) => {
                        if (template) {
                            if (template.id! < 0) {
                                authorizedApiCategory.createCategoryTemplate(new CreateCategoryTemplateRequest({ template: template })).then((data) => {
                                    if (data.ok) {
                                        refreshData();
                                    }
                                });
                            }
                            else {
                                authorizedApiCategory.updateCategoryTemplate(new UpdateCategoryTemplateRequest({ template: template })).then((data) => {
                                    if (data.ok) {
                                        refreshData();
                                    }
                                });
                            }
                        }

                        setSelectedCategory(undefined);

                    }} template={selectedCategory ?? new CategoryTemplateDTO()} />

                <DeleteDialog open={deleteCategory !== undefined} onClose={() => { setDeleteCategory(undefined) }} onDeleteAgree={(del) => {

                    authorizedApiCategory.deleteCategoryTemplate(new DeleteCategoryTemplateRequest({ id: del.id })).then((data) => {
                        if (data.ok) {
                            refreshData();
                        }
                    });
                    setDeleteCategory(undefined);
                }} data={deleteCategory} />
            </DialogContent>
            <DialogActions>
                <Button disabled={buttonDisabled} sx={{ background: theme.palette.primary.main, color: 'black' }} onClick={() => { onClose(false) }}>{t('close')}</Button>
                <Button disabled={!selectionModel || buttonDisabled} sx={{ background: theme.palette.primary.main, color: 'black' }} onClick={() => {
                    setButtonDisabled(true);
                    authorizedApiBuilding.applyCategoryTemplate(new ApplyCategoryTemplateRequest({ buildingId: buildingId!, categoryTemplateId: selectionModel!.id })).then((data) => {
                        if (data.ok) {
                            onClose(true);
                        }
                        setButtonDisabled(false);
                    });
                }}>{t('apply')}</Button>
            </DialogActions>
        </Dialog>
    )
}
